'use strict';
const MapEditorModel = require('../../models/map-editor-model'),
	ColorPickerModel = require('../../models/color-picker-model'),
	NodeStyleEditorModel = require('../../models/node-style-editor-model'),
	ArgumentMappingModel = require('../../models/argument-mapping-model'),
	StickersEditorModel = require('../../models/stickers-editor-model'),
	StickerList = require('../../models/sticker-list'),
	SplittableModel = require('../../models/splittable-model'),
	fontFamilies = require('@mindmup/mapjs-core/src/theme/font-families'),
	textFontFamilies = fontFamilies({textFontOnly: true}),
	FontPickerModel = require('../../models/font-picker-model'),
	updateNodeContent = require('@mindmup/mapjs/src/browser/update-node-content'),
	DraggedImageController = require('@mindmup/mapjs/src/browser/dragged-image-controller'),
	allowedImageTypes = require('../../models/allowed-image-types'),
	mmWidgets = require('../../widgets/mm-widgets');


require('../../widgets/node-line-color-widget');
require('../../widgets/node-line-attr-widget');
require('../../widgets/node-line-label-editor-widget');
require('../../widgets/context-disabler-widget');
require('../../widgets/set-theme-widget');

require('../../widgets/color-picker-widget');
require('../../widgets/font-picker-widget');
require('../../widgets/add-link-crosshairs-widget.js');
require('../../widgets/node-theme-editor-widget');
require('../../widgets/node-style-editor-widget');
require('../../widgets/node-style-editor-color-picker-widget');
require('../../widgets/node-style-editor-font-selector-widget');
require('../../widgets/theme-style-color-picker-widget');
require('../../widgets/theme-style-font-picker-widget');
require('../../widgets/theme-style-font-size-widget');
require('../../widgets/theme-style-border-size-widget');
require('../../widgets/theme-style-corner-radius-widget');
require('../../widgets/theme-style-node-width-widget');
require('../../widgets/text-font-menu-widget');
require('../../widgets/stickers-sidebar-widget');
require('../../widgets/stickers-filter-widget');
require('../../widgets/focus-transfer-widget');

module.exports = function mapEditingStart({config, mapModel, mapThemeModel, collaborationModel, nodeViewModel, themeProvider, ajaxPromise, storage, version, imagePicker} = {}) {
	const mapEditorModel = new MapEditorModel({mapModel, nodeViewModel}),
		splittableModel = new SplittableModel(),
		colorPickerModel = new ColorPickerModel(config.colors, mapEditorModel),
		fontPickerModel = new FontPickerModel(fontFamilies),
		argumentMappingModel = new ArgumentMappingModel(mapModel, mapThemeModel, collaborationModel, mapEditorModel),
		nodeStyleEditorModel = new NodeStyleEditorModel(mapEditorModel, nodeViewModel, themeProvider),
		stickerList = new StickerList(),
		stickersEditorModel = new StickersEditorModel({mapModel, mapEditorModel, ajaxPromise, storage, stickerList, version}),
		initialiseWidgets = function ({stage, domMapController, navigatorShim, domImageDimensionCalculator, pageState, resourceManager, urlDownloader}) {
			if (!stage || !domMapController || !navigatorShim || !domImageDimensionCalculator || !urlDownloader) {
				console.error({stage, domMapController, navigatorShim, domImageDimensionCalculator, pageState, resourceManager, urlDownloader});
				throw new Error('invalid-args');
			}

			stage.nodeLineLabelEditorWidget(mapEditorModel, mapModel)
				.addLinkCrosshairsWidget(mapEditorModel);
			mmWidgets('[data-mm-node-line-attr]').nodeLineAttrWidget(mapEditorModel, stage);
			mmWidgets('[data-mm-node-line-color]').nodeLineColorWidget(mapEditorModel, colorPickerModel);
			mmWidgets('[data-mm-role~="colorPickerWidget"]').colorPickerWidget(colorPickerModel, {imagePicker});
			mmWidgets('[data-mm-role~="fontPickerWidget"]').fontPickerWidget(fontPickerModel);
			mmWidgets('[data-mm-map-editor-context]').contextDisablerWidget(mapEditorModel, 'context', 'data-mm-map-editor-context');
			mmWidgets('[data-mm-set-theme]').setThemeWidget(mapThemeModel);
			mmWidgets('[data-mm-role~="node-type-theme-style-container"]').nodeThemeEditorWidget({mapThemeModel, colorPickerModel, fontPickerModel});
			mmWidgets('[data-mm-role~="node-style-editor-widget"]').nodeStyleEditorWidget(nodeStyleEditorModel, {updateNodeContent});
			mmWidgets('[data-mm-role~="theme-style-color-picker-widget"]').themeStyleColorPicker(mapThemeModel, colorPickerModel);
			mmWidgets('[data-mm-role~="theme-style-font-picker-widget"]').themeStyleFontPicker(mapThemeModel, fontPickerModel);
			mmWidgets('[data-mm-role="theme-style-font-size-widget"]').themeStyleFontSizeWidget(mapThemeModel);
			mmWidgets('[data-mm-role="theme-style-border-size-widget"]').themeStyleBorderSizeWidget(mapThemeModel);
			mmWidgets('[data-mm-role="theme-style-node-width-widget"]').themeStyleNodeWidthWidget(mapThemeModel);
			mmWidgets('[data-mm-role="theme-style-corner-radius-widget"]').themeStyleCornerRadiusWidget(mapThemeModel);
			mmWidgets('[data-mm-node-style-color]').nodeStyleEditorColorPickerWidget(colorPickerModel, nodeStyleEditorModel);
			mmWidgets('[data-mm-role~="node-style-editor-widget"] [data-mm-style-tool=text-font]').nodeStyleEditorFontSelectorWidget(nodeStyleEditorModel, textFontFamilies);
			mmWidgets('[data-mm-role~=text-font-menu]').textFontMenuWidget(mapEditorModel, textFontFamilies);
			mmWidgets('[data-mm-sidebar-name=Stickers]').stickersSidebarWidget({stickersEditorModel});
			mmWidgets('[data-mm-sidebar-name=Stickers]').focusTransferWidget(stage);
			mmWidgets('[data-mm-role=filter-sticker-metadata]').stickersFilterWidget({stickerList, stickersEditorModel, splittableModel});
			mapModel.addEventListener('decorationActionRequested', (nodeId, decType) => {
				if (decType === 'stickers') {
					mapModel.selectNode(nodeId);
					splittableModel.showStickers();
				}
			});
			new DraggedImageController({domMapController, mapModel, navigatorShim, dimensionCalculator: domImageDimensionCalculator, pageState, resourceManager, allowedImageTypes, urlDownloader});
		};

	if (!config || !mapModel || !mapThemeModel || !nodeViewModel || !themeProvider || !ajaxPromise || !storage) {
		throw 'invalid-args';
	}
	return {
		argumentMappingModel,
		mapEditorModel,
		colorPickerModel,
		fontPickerModel,
		nodeStyleEditorModel,
		stickersEditorModel,
		splittableModel,
		initialiseWidgets
	};
};
